import { NgClass } from '@angular/common';
import { Component, input, model, output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { ButtonComponent } from '../button/button.component';
import { HeadlineComponent } from '../headline/headline.component';
import { offcanvasAnimations } from './offcanvas.animations';

@Component({
	selector: 'ui-offcanvas',
	imports: [HeadlineComponent, TranslateModule, ButtonComponent, NgClass],
	templateUrl: './offcanvas.component.html',
	animations: offcanvasAnimations,
})
export class OffcanvasComponent {
	closeAutomatically = input<boolean>(true);
	closeOnOutsideClick = input<boolean>(false);
	header = input<string>('');
	styleClass = input<string>('');
	showCloseButton = input<boolean>(true);

	open = model<boolean>(false);

	closed = output<void>();

	close() {
		if (this.closeAutomatically()) {
			this.open.set(false);
		}
		this.closed.emit();
	}
}
